<template>
  <b-container fluid class="home">

    <b-row class="hero">
      <b-col>

        <b-row>
          <b-col cols="1" />
          <b-col cols="10">
            <h1 class="title">
              <span>How can I </span>
              <span class="bold" style="color: var(--yellow);">Help</span>
            </h1>
          </b-col>
          <b-col cols="1" />
        </b-row>

        <b-row>
          <b-col cols="1" />
          <b-col cols="9">
            <vue-bootstrap-typeahead
                class=""
                v-model="search"
                placeholder="Search"
                prepend-icon="search"
                @keyup.enter="getResults"
                :data="autocomplete"
                @hit="
                  search = `${search.split(' ').slice(0, -1).join(' ')} ${$event}`;
                  getResults();
                "
                :serializer="s => `${search.split(' ').slice(0, -1).join(' ')} ${s}`"
              >
              <template #prepend>
                <b-icon icon="search"/>
              </template>
            </vue-bootstrap-typeahead>
          </b-col>
          <b-col cols="1" class="centered">
            <b-button variant="primary" to="/results">Search</b-button>
          </b-col>
          <b-col cols="1" />
        </b-row>

        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="9">
            <b-row class="row mb-4">
              <b-col style="display: flex; flex-direction: column;
                justify-content: center; flex-grow: 2">
                <b-progress :value="2000 - $store.state.matching_results"
                :max="2000" variant="primary"
                  style="margin-left: var(--search-border-radius)"/>
              </b-col>
              <b-col style="width: fit-content; flex-grow: 0">
                <!-- eslint-disable-next-line vuejs-accessibility/click-events-have-key-events -->
                <small style="white-space: nowrap; margin-right: var(--search-border-radius)"
                @click="$router.push('/article/62b38659069e6d4d4198af7a')">
                  {{$store.state.matching_results}} results
                </small>
              </b-col>
            </b-row>
            <FilterComponent />
          </b-col>
          <b-col cols="2"></b-col>
        </b-row>

      </b-col>
    </b-row>

    <b-row class="recommendation">
      <b-col cols="1" />
      <b-col>
        <h2 id="trends" class="subtitle" style="color: var(--purple)">Trendy Now</h2>
      </b-col>
      <b-col cols="1" />
    </b-row>
    <b-row class="recommendation">
      <b-col cols="1" />
      <b-col>
        <TagsComponent class="trends" />
      </b-col>
      <b-col cols="1" />
    </b-row>

    <b-row class="recommendation">
      <b-col cols="1" />
      <b-col>
        <h2 id="favorites" class="subtitle" style="color: var(--purple)">Favorites</h2>
      </b-col>
      <b-col cols="1" />
    </b-row>
    <b-row class="recommendation">
      <b-col cols="1" />
      <b-col class="trends">
        <p v-if="!$store.state.loggedIn">
          You need to
          <router-link to="/login" style="color: var(--interaction-color)">Login</router-link>
          to view your favorites.
        </p>
        <p v-if="$store.state.loggedIn">
          You haven't added a favorite yet.
        </p>
      </b-col>
      <b-col cols="1" />
    </b-row>
  </b-container>
</template>

<script>
import _ from 'underscore';
import TagsComponent from '@/components/Trends.vue';
import FilterComponent from '@/components/Filter.vue';

export default {
  name: 'HomeView',
  components: {
    TagsComponent,
    FilterComponent,
  },
  data() {
    return {
      search: '',
      autocomplete: [],
    };
  },
  methods: {
    getResults() {
      this.$router.push({
        name: 'results',
        params: {
          query: this.search,
        },
      });
    },
    getAutocomplete() {
    },
  },
  watch: {
    search: _.debounce(function debounce() { this.getAutocomplete(); }, 250),
  },
};
</script>

<style lang="scss">

.hero {
  background: var(--background-color);
  color: var(--text-color);
  padding: 12.5em 0;
  height: 65vh;
  max-height: 100%;
}

.recommendation {
  background: var(--background-color);
  padding-top: 6em;
}

.title {
  font-size: 70px;
  line-height: 70px;
  padding-bottom: 5rem;
}

.subtitle {
  font-size: 48px;
}

.form-control {
  background-color: var(--background-color) !important;
  border: 0 !important;
  color: var(--text-color) !important;
  height: 4em !important;
  border-radius: var(--search-border-radius);
  font-size: 20px;

  &::placeholder {
    color: var(--text-color);
  }

  &:focus {
    outline: none;
    box-shadow: none;
    background-color: var(--interaction-color) !important;
  }
}
.input-group {
  border-radius: var(--search-border-radius);
  border: 2px solid var(--interaction-color);
  &:focus-within {
    background: var(--interaction-color);
  }
}

.input-group-prepend, .input-group-append {
  background-color: inherit;
  padding: 1em;
  display: flex;
  align-items: center;
  border-radius: var(--search-border-radius) 0 0 var(--search-border-radius);
}

.trends {
  margin-bottom: 4em;
}

</style>
